<template>
  <b-card no-body >
    <b-card-body class="px-1 pt-1 pb-0">

      <b-row>
        <!-- Per Page -->
        <b-col
            xl="1"
            md="3"
            sm="6"
            class="mb-sm-1"
        >
          <b-button
              v-if="$can('read', 'Tareo Diario Re')"
              variant="gradient-primary"
              @click="traerReclutados"
              :disabled="loading"
              block
              size="sm"
          >
            <span>Filtrar&emsp;</span>
            <span v-if="loading"><b-spinner style="width: 16px; height: 16px;" /></span>
            <feather-icon v-else icon="RefreshCwIcon" />
          </b-button>

        </b-col>
        <b-col
            xl="2"
            md="3"
            sm="6"
            class="mb-sm-1"
        >
          <b-button
              variant="gradient-warning"
              size="sm"
              @click="descargarFile"
          >
            <span v-if="loading2"> Generando Archivo..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
            <span v-else>
              <feather-icon
                  icon="ExternalLinkIcon"
                  class="mr-50"
              />
              <span class="align-middle">Exportar Excel</span>
            </span>


          </b-button>
        </b-col>

        <b-col
            xl="2"
            md="6"
            sm="6"
        >
          <flat-pickr
              id="rangeFechaFil"
              v-model="rangeDateFil"
              class="form-control"
              :config="{
                    mode: 'range',
                    dateFormat: 'd/m/Y',
                    locale: 'es',

                  }"
              style="height: 31px"

          />

        </b-col>
        <b-col
            xl="3"
            md="6"
            sm="6"
            class="mb-sm-1"
        >
          <v-select
              id="estado_f"
              v-model="lideresSelected"
              :options="optLideres"
              :reduce="optLideres => optLideres.value"
              label="text"
              key="value"
              placeholder="Seleccionar lideres..."
              class="select-size-sm"
          />
        </b-col>

        <b-col
            xl="2"
            md="6"
            sm="6"
        >
          <v-select
              id="idplaca"
              v-model="placaSelected"
              :options="optPlacas"
              :reduce="optPlacas => optPlacas.value"
              label="text"
              key="value"
              placeholder="Seleccionar placa..."
              class="select-size-sm"
          />
        </b-col>
        <!-- Search -->
        <b-col
            xl="2"
            md="3"
            sm="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <!-- filter -->
            <b-form-group
                label-for="filterInput"
                class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Buscar"
                />
                <b-input-group-append>
                  <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                  >
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

    </b-card-body>

    <b-table
        hover
        responsive
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="cPaginacion"
        :busy="loading"
        show-empty
        empty-text="No se encontraron datos en esta tabla."
    >
      <template #table-busy>
        <div class="text-center text-dark my-1">
          <b-spinner class="align-middle"></b-spinner> &emsp;
          <strong>Obteniendo datos...</strong>
        </div>
      </template>
      <template #cell(estado)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>

      <template #cell(dni_reclutado)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(nombres_reclutado)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(region)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(provincia)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(distrito)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(centro_poblado)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(paradero)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>

      <template #cell(latitud)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(longitud)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>

      <template #cell(ubicacion)="data">
        <span class="text-nowrap">
          <b-link
              :href="`https://www.google.com/maps/place/${data.item.latitud},${data.item.longitud}`"
              class="font-weight-bold d-block text-nowrap"
              target="_blank"
          >
              {{data.item.latitud}}, {{data.item.longitud}}
            </b-link>
        </span>
      </template>
      <template #cell(dni_lider_zona)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(nombres_lider)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(fecha_hora_registro)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(fecha_sincronizacion)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(usuario)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(numero_placa)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>

    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
        />

      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>

  </b-card>
</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from "flatpickr/dist/l10n/es.js"

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
  BSpinner,
  BLink,
  BImg,
} from 'bootstrap-vue'
import axios from "axios";

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    BLink,
    BImg,
    flatPickr,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      sortBy: 'id',
      sortDesc: true,
      sortDirection: 'desc',
      filter: null,
      filterOn: [],
      estadoModal: false,
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        {
          key: 'estado',
          label: 'Estado',
          sortable: true
        },
        {
          key: 'dni_reclutado',
          label: 'dni reclutado',
          sortable: true
        },
        {
          key: 'nombres_reclutado',
          label: 'nombres reclutado',
          sortable: true
        },
        {
          key: 'region',
          label: 'region',
          sortable: true
        },
        {
          key: 'provincia',
          label: 'provincia',
          sortable: true
        },
        {
          key: 'distrito',
          label: 'distrito',
          sortable: true
        },
        {
          key: 'centro_poblado',
          label: 'centro poblado',
          sortable: true
        },
        {
          key: 'paradero',
          label: 'paradero',
          sortable: true
        },
        {
          key: 'numero_placa',
          label: 'placa',
          sortable: true
        },
        {
          key: 'ubicacion',
          label: 'Ubicación',
          sortable: true
        },

        {
          key: 'dni_lider_zona',
          label: 'dni lider',
          sortable: true
        },
        {
          key: 'nombres_lider',
          label: 'lider zona',
          sortable: true
        },
        {
          key: 'fecha_hora_registro',
          label: 'fecha registro',
          sortable: true
        },
        {
          key: 'fecha_sincronizacion',
          label: 'fecha carga',
          sortable: true
        },
        {
          key: 'usuario',
          label: 'usuario',
          sortable: true
        },

      ],
      items: [],
      status: [
        {
          1: 'Activo',
          0: 'Inactivo',
        },
        {
          1: 'light-success',
          0: 'light-danger',
        }
      ],
      validacion: null,
      estados: [
        {value: 1, text: "Activo"},
        {value: 0, text: "Inactivo"}
      ],
      codigo: '',
      descrip: '',
      nombre: '',
      estado: {value: 1, text: "Activo"},
      id: 0,
      tipo: 0,
      loading2: false,
      loading: false,
      rangeDateFil : null,
      lideresSelected:'',
      optLideres:[],
      optPlacas:[],
      placaSelected:'',

    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.llenarLideres();
    this.llenarPlacas();
    this.traerReclutados();
  },
  methods: {
    traerReclutados(){
      var yo = this
      yo.loading = true

      if(yo.lideresSelected == '' || yo.lideresSelected == null){
        yo.lideresSelected = yo.optLideres[0].value;
      }
      if(yo.placaSelected == '' || yo.placaSelected == null){
        yo.placaSelected = yo.optPlacas[0].value;
      }

      let fechaRangeTareo = yo.rangeDateFil;
      let fechaInicioRange = ''
      let fechaFinRange = ''

      if(fechaRangeTareo !== null && fechaRangeTareo !== '') {
        let fecha_array = fechaRangeTareo.split(' a ')

        if(fecha_array.length == 2){
          let sep_feha_in = fecha_array[0].split('/');
          let sep_feha_fin = fecha_array[1].split('/');
          fechaInicioRange = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0];
          fechaFinRange = sep_feha_fin[2]+"-"+sep_feha_fin[1]+"-"+sep_feha_fin[0];
        }else{
          let sep_feha_in = fecha_array[0].split('/');
          fechaInicioRange = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0];
          fechaFinRange = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0];

        }
      }else{
        let date_Actual = new Date();
        let date_inicial = yo.addHoursToDate(date_Actual,-144);
        let date_final = yo.addHoursToDate(date_Actual,-0);
        var fecha_inicial = date_inicial.getFullYear() +'-' + String(date_inicial.getMonth() + 1).padStart(2, '0')+'-'+ String(date_inicial.getDate()).padStart(2, '0');
        var fecha_final = date_final.getFullYear() +'-' + String(date_final.getMonth() + 1).padStart(2, '0')+'-'+ String(date_final.getDate()).padStart(2, '0');
        var fecha_inicial_f = String(date_inicial.getDate()).padStart(2, '0')+'/'+String(date_inicial.getMonth() + 1).padStart(2, '0')+'/'+date_inicial.getFullYear();
        var fecha_final_f = String(date_final.getDate()).padStart(2, '0')+'/'+String(date_final.getMonth() + 1).padStart(2, '0')+'/'+date_final.getFullYear();
        this.rangeDateFil = [fecha_inicial_f,fecha_final_f];
        fechaInicioRange = fecha_inicial;
        fechaFinRange = fecha_final;

      }


      var body =  "" +
          "fecha_inicial=" + fechaInicioRange+'&'+
          "fecha_final=" + fechaFinRange+'&'+
          "numero_placa=" + yo.placaSelected+'&'+
          "lider=" +yo.lideresSelected
          "";

      var config = {
        method: 'get',
        url: '/reclutamiento/reclutamiento/personal/list/all/?'+body,
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.items = response.data.respuesta;
              yo.totalRows = yo.items.length
            }

          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
          });
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: 5000
          })
    },

    descargarFile(){
      var yo = this
      this.loading2 = true

      if(yo.lideresSelected == '' || yo.lideresSelected == null){
        yo.lideresSelected = yo.optLideres[0].value;
      }
      if(yo.placaSelected == '' || yo.placaSelected == null){
        yo.placaSelected = yo.optPlacas[0].value;
      }

      let fechaRangeTareo = yo.rangeDateFil;
      let fechaInicioRange = ''
      let fechaFinRange = ''

      if(fechaRangeTareo !== null && fechaRangeTareo !== '') {
        let fecha_array = fechaRangeTareo.split(' a ')

        if(fecha_array.length == 2){
          let sep_feha_in = fecha_array[0].split('/');
          let sep_feha_fin = fecha_array[1].split('/');
          fechaInicioRange = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0];
          fechaFinRange = sep_feha_fin[2]+"-"+sep_feha_fin[1]+"-"+sep_feha_fin[0];
        }else{
          let sep_feha_in = fecha_array[0].split('/');
          fechaInicioRange = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0];
          fechaFinRange = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0];

        }
      }else{
        let date_Actual = new Date();
        let date_inicial = yo.addHoursToDate(date_Actual,-144);
        let date_final = yo.addHoursToDate(date_Actual,-0);
        var fecha_inicial = date_inicial.getFullYear() +'-' + String(date_inicial.getMonth() + 1).padStart(2, '0')+'-'+ String(date_inicial.getDate()).padStart(2, '0');
        var fecha_final = date_final.getFullYear() +'-' + String(date_final.getMonth() + 1).padStart(2, '0')+'-'+ String(date_final.getDate()).padStart(2, '0');
        var fecha_inicial_f = String(date_inicial.getDate()).padStart(2, '0')+'/'+String(date_inicial.getMonth() + 1).padStart(2, '0')+'/'+date_inicial.getFullYear();
        var fecha_final_f = String(date_final.getDate()).padStart(2, '0')+'/'+String(date_final.getMonth() + 1).padStart(2, '0')+'/'+date_final.getFullYear();
        this.rangeDateFil = [fecha_inicial_f,fecha_final_f];
        fechaInicioRange = fecha_inicial;
        fechaFinRange = fecha_final;

      }


      var body =  "" +
          "fecha_inicial=" + fechaInicioRange+'&'+
          "fecha_final=" + fechaFinRange+'&'+
          "numero_placa=" + yo.placaSelected+'&'+
          "lider=" +yo.lideresSelected
      "";

      var config = {
        method: 'post',
        url: 'https://www.agvperu.com/dms/Jaspergen/exportExcelPersonalReclutado?'+body,
        headers: { }
      };

      axios(config)
          .then(function (response) {
            var content = JSON.stringify(response.data);

            //if(content === "ok"){
            yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Archivo descargado',
                    icon: 'CheckIcon',
                    text: 'El archivo se descargó satisfactoriamente.',
                    variant: 'success',
                  },
                },
                {
                  position: 'top-center',
                })
            window.location.href = 'https://www.agvperu.com/dms/Jaspergen/downloadExcelJasperPersonalReclutado';

            // }

          })
          .catch(function (error) {
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
            console.log("error1: "+error);
          }).finally(function () {
            yo.loading2 = false
          });

    },
    addHoursToDate(objDate, intHours) {
      var numberOfMlSeconds = objDate.getTime();
      var addMlSeconds = (intHours * 60) * 60000;
      var newDateObj = new Date(numberOfMlSeconds + addMlSeconds);

      return newDateObj;
    },
    llenarLideres(){
      var yo = this

      yo.optLideres = [];
      yo.optLideres.push({value: 'T', text:"TODOS LOS LIDERES"});
      yo.lideresSelected = yo.optLideres[0].value;

      var config = {
        method: 'get',
        url: '/reclutamiento/reclutamiento/lideres/zona/'
      };

      axiosIns(config)
          .then((response) => {
            var respons = response.data;
            var totalRows = respons.length;
            for (var i = 0 ; i <  totalRows; i++){
              var nombres  = respons[i].apellidos + " " + respons[i].nombres;
              yo.optLideres.push({value: respons[i].dni, text:nombres});
            }
          })
          .catch(function (error) {
            console.log(error);
          }).finally(function (){
      });

    },
    llenarPlacas(){
      var yo = this

      yo.optPlacas = [];
      yo.optPlacas.push({value: 'T', text:"TODAS LAS PLACAS"});
      yo.placaSelected = yo.optPlacas[0].value;

      var config = {
        method: 'get',
        url: '/reclutamiento/reclutamiento/placa/list/'
      };

      axiosIns(config)
          .then((response) => {
            var respons = response.data;
            var totalRowsPlaca = respons.length;
            for (var i = 0 ; i <  totalRowsPlaca; i++){
              yo.optPlacas.push({value: respons[i].numero_placa, text:respons[i].numero_placa});
            }
          })
          .catch(function (error) {
            console.log(error);
          }).finally(function (){
      });

    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
